import {elementNameConst, shapeTypeConst} from '../../../conf';

/**
 * 拓扑插件-自定义单控制节点单弧度动画曲线-扩展
 */
export default {
  name: shapeTypeConst.lineLiquidFillRunning,
  type: elementNameConst.edge,
  options: {
    /**
     * 绘制后的附加操作，默认没有任何操作
     * @param cfg 边的配置项
     * @param group 图形分组，边中的图形对象的容器
     */
    afterDraw(cfg, group) {
      // 获得组中的第一个形状，这是边的路径=
      const shape = group.getFirst();
      // 边缘路径的起始位置
      // const startPoint = shape.getPoint(0.5);
      const startPoint = cfg.startPoint;
      const endPoint = cfg.endPoint;

      // 添加红色圆形
      const imgShape = group.addShape('image', {
        attrs: {
          // 分别减去图形 width / 2 和 height / 2
          x: startPoint.x,
          y: startPoint.y,
          img: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAhCAYAAADtR0oPAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAZdEVYdFNvZnR3YXJlAEFkb2JlIEltYWdlUmVhZHlxyWU8AAAB2ElEQVQ4T32USU7DQBBFbcKMAAFigcSSg3ADtmzZc0juwQ6JMA9hCBAG81/Rv9W2HEp6cae7fk1tuW6appLVCWwmPTEOw0H2ww8CHHEaiLmERTh9ic/0bBBwiNOiWE7MCwynsXgVH2KCYFYLnNfFhtgSiMj8Lu4TIzFGQLQ1sS12xZFA8CZuxYk4FVdiRDmwIBDtiH1xIA7FsdgTZF4SA5xJTcNE3RSeio1gq4I+a08DAaWtiBhfMpqmP0T0mgXlaL/ZSMY4icx+3JMFRKUUnozPNhHs+TzuwBtEJiJztzEpAlBaXBwCR0bAIZdkQ2xBBC4FbJLhWdhehAUEzBn4A9SMkw0xe87QKolNDh+FjTUZyEzAXJKzcMA7Y0PgDFNLehC2O9HbQ5mBHnDAeEvLKYUA448z8EozTvZ4W8sessAZEHBZ3AWi8h6ikq6ASGSgrCfRvbj8LiFgk0MEzJ9psfaU8Gm9fGVJRKdhMljQyoCx6ZIYLSN1hmhYtEpik5LIgPNNWpdNt0pik2hEZZyXad1bkpt2D0S/EGUPvSW5Bz4pQ0E5UzN4Sjhdi3Pxb9NEcQbqPxNuGEGYv94Iux9ll1ESH2M9wywyWDj9LWOdM9hKZxsOyamqfgG1ZQ8JFbfSTwAAAABJRU5ErkJggg=='
        },
        name: 'quadratic-liquid-fill-shape'
      });

      // 动画配置
      const animateCfg = {
        // 是否重复执行动画
        repeat: true,
        // 执行一次的持续时间
        duration: 3000
      };
      // console.log(cfg.getSource(), cfg.getTarget(), '线');

      // const rotateMatrix = graphUtil.transform([1, 0, 0, 0, 1, 0, 0, 0, 1], [
      //   ['t', -startPoint.x, -startPoint.y],
      //   ['r', 0.3],
      //   ['t', startPoint.x, startPoint.y]
      // ]);
      // imgShape.setMatrix(rotateMatrix);
      // console.log(rotateMatrix);


      // imgShape.rotate(0.6);


      const point = {x: endPoint.x - startPoint.x, y: endPoint.y - startPoint.y};
      const rad = Math.atan2(point.y, point.x);
      // const rotation = rad / Math.pi * 180;
      // let angle = 360 - rotation + 90;
      // angle = angle < 0 && 360 + angle;
      // angle = angle % 360;
      // const dir = Math.floor(angle / 360 * 24);

      const num = rad * (180 / Math.PI);
      console.log(num, '数据');



      // 液体水滴流向动画
      imgShape.animate((ratio) => {
        // 每个帧中的操作。比率范围从0到1，表示动画的进度。返回修改后的配置
        // 根据比率获得边缘上的位置
        const tmpPoint = shape.getPoint(ratio);


        // const toMatrix = graphUtil.transform(
        //   [1, 0, 0, 0, 1, 0, 0, 0, 1],
        //   [['r', ratio * Math.PI * 2]]
        // );
        // imgShape.setMatrix(toMatrix);
        // console.log(tmpPoint);


        // var  p1:Point =  new  Point( 40 , 30 );
        // var  p2:Point =  new  Point( 80 , 60 );
        //
        // var  angle: Number  = Math.atan2((p2.x - p1.x), (p2.y - p1.y))  //弧度  0.9272952180016122
        // var  theta: Number  = angle*( 180 /Math.PI);  //角度  53.13010235415598




        // 在此处返回修改后的配置，在此处返回x和y，分别减去图形 width / 2 和 height / 2
        return {
          x: tmpPoint.x - 6,
          y: tmpPoint.y - 14
        };
      }, animateCfg);
    }
  },
  // 继承节点名
  extendedNodeName: shapeTypeConst.line
};
